
<script>
import request from "./request.vue";
import session from "./session.vue";

export default {
  get: async function(limitVideo = null) {
    try {
      if (limitVideo) {
        const resp = await request.send(
          `https://api.japanparts.com.br/api/videos?filter[limit]=${limitVideo}`,
          {},
          false,
          "get"
        );
        return resp;
      } else {
        const resp = await request.send(
          "https://api.japanparts.com.br/api/videos",
          {},
          false,
          "get"
        );
        return resp;
      }
    } catch (error) {
      console.log(error);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/api/video.vue